import {useEffect} from "react";
import {useLocation} from "react-router";
import {useTranslation} from "react-i18next";

export default function ScrollToTop() {
    const {pathname} = useLocation();
    const {t} = useTranslation();

    useEffect(() => {
        const key = `title.${encodeURIComponent(pathname)}`;
        const title = t(key);
        if (title !== key) {
            document.title = `${title} - diwi.ro`
        } else {
            document.title = 'Diwi.ro - Dream It Wear It'
        }

        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    return null;
}